"use strict";

exports.__esModule = true;
exports.AccordionSortableRows = void 0;
var _core = require("@blueprintjs/core");
var _react = _interopRequireWildcard(require("react"));
var _SortableRows = require("./SortableRows");
var _styles = require("./styles");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var AccordionSortableRows = exports.AccordionSortableRows = function AccordionSortableRows(props) {
  var getHeader = props.getHeader,
    isOpen = props.isOpen,
    getKey = props.getKey;
  var renderItem = function renderItem(v, i, a) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_styles.ButtonAndInput, null, /*#__PURE__*/_react["default"].createElement(_core.Button, {
      "data-testid": "Button-" + (getKey && getKey(v, i, a)),
      minimal: true,
      small: true,
      alignText: "left",
      icon: isOpen(v, i, a) ? "chevron-down" : "chevron-right",
      onClick: function onClick() {
        return props.toggleItem(v, i, a);
      }
    }), getHeader && getHeader(v, i, a)), props.renderItem(v, i, a));
  };
  return /*#__PURE__*/_react["default"].createElement(_SortableRows.SortableRows, _extends({}, props, {
    renderSubRow: function renderSubRow(v, i, a) {
      return isOpen(v, i, a) ? props.renderSubRow(v, i, a) : undefined;
    },
    renderItem: renderItem,
    Container: props.Container || _styles.AccordionContainer
  }));
};